<template>
  <div class="combine-pay">
    <!-- notify bar -->
    <div class="notify-bar" v-if="hasNotify">
      <div class="notify-bar-container" @click="popupNotify">
        <icon-notify class="icon-notify"/>
        合并支付优惠
      </div>
    </div>

    <!-- header bar -->
    <div id="select-all">
      <div class="header-wrap" :class="hasNotify&&'with-notify'">
        <button class="_left" @click="handleCheckAll">
          <circle-checkbox :checked="isAllChecked" class="order-checkbox"/>
          <div>全选</div>
        </button>
        <button type="button" class="_right" @click="onceMore">再来一单</button>
      </div>
    </div>

    <!-- list container -->
    <div id="order-container-c"
         v-infinite-scroll="getCombineList"
         :infinite-scroll-disabled="isLoading || isEnd"
         infinite-scroll-distance="0">
         <div>
          <div class="order-card-wrap"
              v-for="(order, index) in waitToPayList"
              :key="order.id">
            <div class="_checkbox" @click="handleCheck(order, index)">
              <circle-checkbox :checked="order['_isChosen']" class="order-checkbox"/>
            </div>

            <router-link tag="div" class="_wrap" :to="`/order-detail/${order.id}`">
              <order-card :view-data="order"/>
            </router-link>
          </div>
         </div>
      <div class="loadingpos">
        <loading v-show="isLoading" :no-transition="true" :show="true">获取数据</loading>
      </div>
      <div v-if="!isLoading && !waitToPayList.length" class="_empty"> - 没有未支付的订单 - </div>
    </div>
    <!-- foot bar -->
    <div class="price-bar">
      <div class="price-container">
        <div class="price-info" v-show="isCheckingPrice">
          <loading :no-transition="true" :show="true"/>
        </div>
        <div class="price-info" v-show="!isCheckingPrice">
          <div class="main-info">
            应付款：
            <span class="price-unit">¥</span>
            <span class="price-number">{{prices.total_price/100}}</span>
          </div>
          <div class="sub-info">
            <template v-if="prices.discount_pice">
              已优惠：
              <span class="price-unit">¥</span>
              <span class="price-number">{{prices.discount_pice/100}}</span>
            </template>
            <template v-else>
              <span style="color: rgba(116, 116, 116, 1)">无优惠</span>
            </template>
          </div>
        </div>
      </div>
      <button class="submit" :class="{'disable': !canSubmit}" @click="submit">合并支付</button>
    </div>


    <!-- 合并支付优惠弹出提示 -->
    <mt-popup v-model="notifyShow"
              :modalFade="true"
              :lockScroll="true"
              :close-on-click-modal="true"
              popup-transition="popup-fade"
              :modal="true">
      <div class="notify-box" v-show="notifyType==='discount'">
        <div class="_top">
          <h3 class="_title">合并支付优惠</h3>
          <p class="_main">相同快递信息（收件人姓名、电话、收件地址完全相同）的冲印订单合并支付享受如下优惠：</p>
          <p class="_highlight _sub">满2版享8折，满3版享7折<br>不同快递信息的订单合并支付无优惠</p>
          <p class="_highlight _sub">加急快递和普通快递的订单合并支付无优惠</p>
        </div>

        <div class="foot">
          <button class="confirm-btn" @click="popupNotify(false)">我知道了</button>
        </div>
      </div>
      <div class="notify-box" v-show="notifyType==='submit'">
        <div class="_top">
          <p class="_main" style="font-size: 16px; letter-spacing: 3px;" align="center">你只选中了1单，确定放弃合并支付优惠吗？</p>
        </div>
        <div class="foot">
          <button class="cancel-btn" @click="submit('one')">直接支付</button>
          <button class="confirm-btn" @click="popupNotify(false)">重新选择</button>
        </div>
      </div>
    </mt-popup>
  </div>
</template>

<script>
  import {getPayType} from "@/utils/utils";
  import {Popup, Toast, MessageBox} from 'mint-ui';
  import {mapActions,mapState} from 'vuex';
  import CircleCheckbox from '../components/CircleCheckbox';
  import OrderCard from "../components/OrderCard";
  import NotifyBar from "../components/NotifyBar";
  import IconNotify from "../components/Icon/IconNotify";
  import Loading from "../components/Loadingb";

  export default {
    components: {
      Loading, IconNotify, NotifyBar, OrderCard, CircleCheckbox,
      [Popup.name]: Popup,
    },
    activated() {
      if(!this.actiBol){
        return;
      }
      this.isEnd = false;
      this.waitToPayList = [];
      this.combineListParams= {
        page: 0,
        per_page: 20,
        total_required: true,
        state: 'waiting'
      },
      this.getCombineList()
      this.checkedList = []
    },
    methods: {
      ...mapActions(["getPrintList","checkOrder","smo","printPay"]),
      popupNotify(isNotifyShow = true, type = 'discount') {
        if (isNotifyShow) {
          this.notifyType = type
        } else {
          setTimeout(() => this.notifyType = type, 300)
        }

        this.notifyShow = !!isNotifyShow
      },

      handleCheck(order, index) {
        let save_key = 'id';
        let currCheckState = !!order['_isChosen']
        if (currCheckState) { // remove from list
          let indexInCheckedList = this.checkedList.findIndex(item => item === order[save_key])

          this.checkedList.splice(indexInCheckedList, 1)
        } else { // add to list
          this.checkedList.push(order[save_key])
        }

        order['_isChosen'] = !currCheckState
        this.$set(this.waitToPayList, index, order)
      },

      handleCheckAll() {
        let currCheckList = [...this.checkedList]
        let currAllCheckState = this.isAllChecked
        let list = this.waitToPayList.map(item => {
          // 如果当前项目选中状态 === 点击时的全选状态
          if (!!item['_isChosen'] === !!currAllCheckState) {
            // update item check state
            item['_isChosen'] = !currAllCheckState
            // update id`s list of checked items
            let indexInCheckedList = currCheckList.findIndex(id => id === item.id)
            if (indexInCheckedList !== -1) {
              currCheckList.splice(indexInCheckedList, 1)
            } else {
              currCheckList.push(item.id)
            }
          }
          return item
        })

        this.$set(this, 'waitToPayList', list)
        this.$set(this, 'checkedList', currCheckList)
      },

      getCombineList() {
        if (this.isLoading || this.isEnd) return
        this.isLoading = true
        let params = {
          ...this.combineListParams,
          page: this.combineListParams.page + 1,
        }

        return this.getPrintList(params).then(({data}) => {
          if (data.length === 0)
            return this.isEnd = true;

          let list = data.filter(item => item.state === 'waiting')
          this.waitToPayList.push(...list)
          this.$set(this, 'combineListParams', params)
        }, err => {
          console.log(err)
        }).then(() => {
            this.isLoading = false
        })
      },

      onceMore() {
        this.sdk.reLaunchTo("pages/index/index");
      },

      async submit(arg) {
        if (!this.canSubmit)
          return;
        if (this.isSubmiting || this.isCheckingPrice)
          return Promise.reject();

        this.isSubmiting = true;
        let currOrderItem, type
        if (arg === 'one') {
          // 单独订单支付
          let theOne = this.waitToPayList.find(item => item.id === this.checkedList[0])
          type = 'single'
          currOrderItem = theOne
        } else if (this.checkedList.length <= 1) {
          // 单独订单支付前弹出提示框选择
          this.isSubmiting = false
          return this.popupNotify(true, 'submit')
        } else {
          // 合并支付
          let {data} = await this.smo({order_id_list: `[${this.checkedList.join(',')}]`})
          type = 'merge'
          currOrderItem = data
        }

        this.isSubmiting = false;
        let paramType = getPayType(this.platformInfo.platform,type);
        this.printPay({orderId:currOrderItem.id, type:paramType}).then(res => {
          console.log(res);
          let payObj = {}
          if(this.platformInfo.platform === 'wechat'){
            payObj = res.data.signed_string
            payObj.orderId = currOrderItem.id;
            payObj.description = "gopay";
            payObj.type = type;
          }
          if(this.platformInfo.platform === 'baidu'){
            payObj = {...res.data.orderInfo};
            payObj.orderId = currOrderItem.id;
            payObj.description = "gopay";
            payObj.type = type;
          }
          this.sdk.gopay('pages/miniApi/miniApi', payObj);
        })
        // setTimeout(() => {
        //   this.$router.push({
        //     name: `payment-${type}`,
        //     params: {id: currOrderItem.id}
        //   })
        // }, 100)
      },

      async checkMergeOrder(list) {
        this.isCheckingPrice = true;
        try{
          let {data:{discount_price,total_price} = {discount_price:0,total_price:0}} = await this.checkOrder({orderIdList:list});
          this.$set(this, 'prices', {
            discount_pice: parseInt(discount_price),
            total_price: parseInt(total_price)
          })
          setTimeout(() => {
            this.isCheckingPrice = false
          }, 150)
        }catch (e){
          console.log(e);
          this.isCheckingPrice = false;
        }
        
      },
    },

    computed: {
      ...mapState(['platformInfo', 'actiBol']),
      isAllChecked() {
        if (!this.waitToPayList.length)
          return false

        return this.waitToPayList.every(item => {
          return !!item['_isChosen']
        })
      },

      canSubmit() {
        return !!this.checkedList.length
      }
    },

    watch: {
      checkedList: {
        deep: true,
        handler(val) {
          this.checkMergeOrder([...val])
        }
      },
    },


    data() {
      return {
        waitToPayList: [],
        totalPrice: '',
        notifyShow: false,
        notifyType: 'discount',
        hasNotify: true,
        isLoading: false,
        isCheckingPrice: false,
        isEnd: false,
        checkedList: [],
        prices: {
          discount_pice: 0,
          total_price: 0
        },
        combineListParams: {
          page: 0,
          per_page: 20,
          total_required: true,
          state: 'waiting'
        },
        isSubmiting: false,
      };
    },
  };
</script>
<style scoped lang="scss">
  .combine-pay {
    min-height: 100%;
    background-color: #fff;

    * {
      box-sizing: border-box;
    }

    .notify-bar {
      width: 100%;
      height: 0.38rem;
      position: relative;

      .notify-bar-container {
        width: 100vw;
        height: 0.38rem;
        position: fixed;
        z-index: 50;
        left: 0;
        top: 0;
        background-color: rgba(221, 232, 255, 1);
        color: rgba(53, 53, 53, 1);
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 0.14rem;
      }

      .icon-notify {
        margin: 0 0.08rem 0 0.16rem;
      }
    }

    #select-all {
      width: 100%;
      height: 0.5rem;
      position: relative;

      .header-wrap {
        display: flex;
        height: 0.5rem;
        width: 100vw;
        padding: 0 0.12rem;
        font-size: 0.14rem;
        align-items: stretch;
        justify-content: space-between;
        background: white;
        box-shadow: 0 2px 4px 0 rgba(239, 239, 239, 1);
        position: fixed;
        top: 0;
        left: 0;
        z-index: 50;

        &.with-notify {
          top: 0.38rem;
        }
      }

      ._left {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      ._right {
        color: rgba(68, 85, 228, 1);
      }
    }

    .order-checkbox {
      margin-right: 0.14rem;
    }

    .box2 {
      background: white;
      border-bottom: 1px solid rgba(151, 151, 151, 0.15);
      align-items: center;
    }

    #order-container-c {
      padding-bottom: 1rem;
      position:relative;
      .loadingpos {
        width: 100%;
        position: absolute;
        bottom: 0.6rem;
        left: 0;
      }
      .order-card-wrap {
        box-sizing: border-box;
        background-color: #fff;
        width: 100%;
        padding: 0.24rem 0.16rem 0.24rem 0.12rem;
        display: flex;
        align-items: stretch;
        justify-content: space-between;
        & + .order-card-wrap {
          border-top: 1px solid rgba(151, 151, 151, 0.15);
        }
        ._checkbox {
          display: flex;
          flex-shrink: 0;
          align-items: center;
        }

        ._wrap {
          width: 100%;
        }
      }
    }
  }

  .mint-popup {
    background-color: transparent;
  }

  ._empty {
    font-size: 0.14rem;
    color: rgba(54, 54, 54, 0.5);
    text-align: center;
    line-height: 2;
    margin-top: 0.12rem;
  }

</style>
